import { useMutation } from "@tanstack/react-query";
import { usePymbleApi } from "./usePymbleApi";

const REPORT_END_POINT = "/group/admin/report";

/**
 * Hook to fetch api data from group reports api.
 */
export function useGroupReports() {
  const { callApi } = usePymbleApi();

  const mutation = useMutation({
    mutationFn: async ({
      roles,
      contacts,
      types,
    }: {
      roles: string[];
      contacts: string[];
      types: string[];
    }) => {
      const request = {
        roles: roles,
        contacts: contacts,
        group_types: types,
      };
      return await callApi("POST", REPORT_END_POINT, { data: request });
    },
  });

  const refreshGroupMemberData = async (
    roles: string[],
    contacts: string[],
    types: string[]
  ) => {
    return mutation.mutateAsync({ roles, contacts, types });
  };

  return {
    reportData: mutation.data ?? [],
    reportDataLoaded: !mutation.isPending,
    refreshGroupMemberData,
  };
}
